import { generatePath } from "react-router-dom";

import { flow } from "fp-ts/lib/function";

import { AbsoluteRoute } from "../../../core/routes";
import { type ResourceContainer } from "../../../gql-generated/types";
import { type PreSubmissionInfoFragment } from "../../api/fragments";

type SubmissionRoute =
    | AbsoluteRoute.SUBMIT_ACCOUNT_SELECT
    | AbsoluteRoute.SUBMIT_LENS_FOLDER_SELECT
    | AbsoluteRoute.CREATE_ORG_LENS_FOLDER;

const createDeriveLensSubmissionRoute =
    (
        { isSameUser }: PreSubmissionInfoFragment,
        organizations: readonly ResourceContainer[],
        submitUnderDifferentAccount = false,
    ) =>
    (): SubmissionRoute => {
        const hasOrganizations = organizations.length > 0;

        if (!isSameUser && !submitUnderDifferentAccount) {
            return AbsoluteRoute.SUBMIT_ACCOUNT_SELECT;
        } else if (hasOrganizations) {
            return AbsoluteRoute.SUBMIT_LENS_FOLDER_SELECT;
        } else {
            return AbsoluteRoute.CREATE_ORG_LENS_FOLDER;
        }
    };

const buildSubmissionRoute =
    (submissionId: string) =>
    (route: SubmissionRoute): string => {
        return generatePath(route, { submissionId, routeTo: "submit" });
    };

export const getLensSubmissionRouteV2 = (
    getPreSubmissionInfo: PreSubmissionInfoFragment,
    organizations: readonly ResourceContainer[],
    submissionId: string,
    submitUnderDifferentAccount = false,
): string => {
    return flow(
        createDeriveLensSubmissionRoute(getPreSubmissionInfo, organizations, submitUnderDifferentAccount),
        buildSubmissionRoute(submissionId),
    )();
};
